const FLAG_PREFIX = 'accountTickersNeedsRefresh';

const getStorage = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

const getFlagKey = (accountId) => {
  if (accountId === null || accountId === undefined) {
    return null;
  }
  return `${FLAG_PREFIX}-${accountId}`;
};

export const markAccountTickersRefreshRequired = (accountId) => {
  const storage = getStorage();
  const key = getFlagKey(accountId);

  if (!storage || !key) {
    return;
  }

  try {
    storage.setItem(key, 'true');
  } catch (error) {
    // ignore storage errors
  }
};

export const clearAccountTickersRefreshFlag = (accountId) => {
  const storage = getStorage();
  const key = getFlagKey(accountId);

  if (!storage || !key) {
    return;
  }

  try {
    storage.removeItem(key);
  } catch (error) {
    // ignore storage errors
  }
};

export const isAccountTickersRefreshRequired = (accountId) => {
  const storage = getStorage();
  const key = getFlagKey(accountId);

  if (!storage || !key) {
    return false;
  }

  try {
    return storage.getItem(key) === 'true';
  } catch (error) {
    return false;
  }
};
